<template>
  <v-dialog v-model="show" persistent :max-width="maxWidth">
    <v-card>
      <v-card-title class="headline" v-text="title"></v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat v-on:click.native="close()">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      show: false,
      title: '',
      message: '',
      maxWidth: 300,
      resolve: null,
      reject: null
    }
  },
  methods: {
    open(title, message) {
      this.title = title
      this.message = message
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close() {
      this.show = false
      this.resolve(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Dialog.vue